import {fetch} from "utils/dataAccess";

export function error(error) {
    return {type: "GENDER_UPDATE_POSITION_ERROR", error};
}

export function loading(loading) {
    return {type: "GENDER_UPDATE_POSITION_LOADING", loading};
}

export function success(updated) {
    return {type: "GENDER_UPDATE_POSITION_SUCCESS", updated};
}

export function updatePosition(params) {
    return dispatch => {
        dispatch(loading(true));

        return fetch('/genders/update_position', {method: "POST", body: JSON.stringify(params)})
            .then(() => {
                dispatch(loading(false));
                dispatch(success(params));
            })
            .catch((e) => {
                dispatch(loading(false));
                dispatch(error(e.message));
            });
    };
}